var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:[
    _vm.css(),
    _vm.css('', _vm.type),
    _vm.css('', _vm.size),
    ( _obj = {}, _obj[_vm.css('', _vm.AtomButtonTypeEnum.DISABLED)] = _vm.isDisabled, _obj[_vm.css('', 'loading')] = _vm.isLoading, _obj[_vm.css('', 'compact')] = _vm.compact, _obj[_vm.css('', 'wide')] = _vm.size === _vm.AtomButtonSizeEnum.LARGE_WIDE, _obj ) ],attrs:{"disabled":_vm.isDisabled || _vm.isLoading,"data-test":"atom-button"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'button',_vm.$attrs,false),[(_vm.isLoading)?_c('div',{class:_vm.css('circle'),attrs:{"data-test":"loading"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }